
import PreviewDListlImg from 'assets/images/feature-slots/preview_list.png';
import { SLOT_KEY, GLOBAL_LAYOUT_KEY } from '../common';

const routes = [
    {
        matchRegex: GLOBAL_LAYOUT_KEY,
        name: 'Global layout',
        slots: [SLOT_KEY.SLOT_SCRIPTS],
        image: PreviewDListlImg,
        options: {
            [SLOT_KEY.SLOT_SCRIPTS]: [
                {
                    key: 'MARKETPLACE_EVENT_UPDATE_LEFT_SIDEBAR',
                    label: 'Trigger Updated Left Sidebar',
                },
            ],
        },
    },
]

export default routes;